// extracted by mini-css-extract-plugin
module.exports = {"text":"CustomFieldsPanel_text__x6HRg","hint":"CustomFieldsPanel_hint__b3QSy","columnLabel":"CustomFieldsPanel_columnLabel__RnyaH"};